<template lang="pug">
  .component.component-backoffice-deposit(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        .row

          .column
            h3 D{{item.id}}
            small(:style="item.status === 'FAIL' ? 'color:red':''") {{item.status}}

          .column.shrink
            .label Date
            .field-value {{$dateFormat(item.created_at, $toMomentFormat(configuration.locale.locale_date_format.value))}}
        .row
          .column
            .field-value {{item.reason}}
        .row.text-center
          .column
            .label Amount
            h3 {{$priceWithcurrency(item.amount)}}
          .column
            .label Walletable
            h3(v-if="walletable")
              router-link(:to="{name:'reservation', params:{id:item.walletable_id}}") {{walletable}}{{item.walletable_id}}
          .column
            .label Invoice
            h3(v-if="item.invoice_id")
              router-link(:to="{name:'invoice', params:{id:item.invoice_id}}") INV{{item.invoice_id}}
            .field-value(slot="n6", v-else) not invoiced
</template>
<script type="text/babel">
    import CardN from 'components/structure/CardN'
    import Dropdown from '../structure/foundation/Dropdown'
    import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
    import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
    import TocButtons from '../structure/ui/actions/TocButtons'
    import {mapState} from 'vuex'

    export default {
        name: 'Deposit',
        components: {
            TocButtons,
            VehicleNoteButtons,
            VehicleCostButtons,
            Dropdown,
            CardN,
        },
        data() {
            return {}
        },
        created() {
        },
        methods: {},
        computed: {
            ...mapState({
                configuration: state => state.configuration,
            }),
            walletable() {
                return this.item.walletable_type ? this.item.walletable_type.replace(/App\\Models\\Reservation/, 'R') : null
            }
        },
        props: {
            item: Object,
            type: {
                type: String,
                default: ''
            }
        },
    }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-deposit
    h3
      margin-bottom: 0
</style>



// WEBPACK FOOTER //
// Deposit.vue?6aabd192